import { Button } from '@/components/ui/button'
import GameLayout from '@/layouts/GameLayout'
import { useNavigate } from 'react-router'

interface SurveyErrorStateProps {
  title: string
  message: string
  buttonText?: string
}

export const SurveyErrorState = ({
  title,
  message,
  buttonText = 'Quay lại trang chủ',
}: SurveyErrorStateProps) => {
  const navigate = useNavigate()

  return (
    <GameLayout>
      <div className="w-full max-w-[1300px] mx-auto px-4">
        <div className="mb-12">
          <h1 className="xl:text-[30px] mb-6 text-[24px] font-bold leading-tight text-black">
            {title}
          </h1>
        </div>
        <div className="space-y-8">
          <div className="animate-in fade-in slide-in-from-bottom duration-500">
            <div className="mb-6">
              <div className="relative inline-block max-w-[80%]">
                <div className="bg-primary rounded-[32px] px-8 py-5 text-white shadow-lg">
                  <p className="md:text-xl text-lg font-normal leading-relaxed">{message}</p>
                </div>
                <svg
                  className="left-2 -bottom-2 absolute"
                  width="40"
                  height="30"
                  viewBox="0 0 40 30"
                  fill="none"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <path
                    d="M15 0 Q20 10, 25 20 Q20 25, 10 30 Q12 15, 15 0"
                    fill="currentColor"
                    className="text-primary"
                  />
                </svg>
              </div>
            </div>
          </div>
        </div>
        <div className="flex justify-center mt-12">
          <Button onClick={() => navigate('/')} className="btn-primary">
            {buttonText}
          </Button>
        </div>
      </div>
    </GameLayout>
  )
}
